import React, {lazy, Suspense, useCallback, useState} from 'react';
import styled from "styled-components";
import ChampionsHeader from "../ChampionsHeader";
import ChampionsWhiteWrapper from "../ChampionsWhiteWrapper";
import SearchListByLane from "./SearchListByLane";
import ChampionsBar from "../ChampionsBar";
import ChampionsCname from "./ChampionsCName";
import ChampionsInput from "../ChampionsInput";
import {Loading} from "../../../common";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

const ChampionsList = lazy(() => import("./ChampionsList"));


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 84%;
  margin-right: 5px;
`;

const ChampionsSearch = () => {
    const {t} = useTranslation();
    const [choVisible, setChoVisible] = useState(false);
    const [indivisualVisible, setindivisualVisible] = useState('');
    const [laneVisible, setLaneVisible] = useState('all');
    const championData = useSelector((state) => state?.imageStore.champions);

    const onClickCname = useCallback((value) => {
        if (value !== undefined && (typeof value === 'string' || typeof value === 'boolean')) {
            setChoVisible(value);
        }
    }, []);

    const onChangeINidivisualVisible = useCallback((value) => {
        setindivisualVisible(value)
    }, []);

    const onClickLane = useCallback((index, value) => {
        if(typeof value === 'string') {
            const result = value.toLowerCase()
            setLaneVisible(result);
        }

    }, []);

    return (
        <Wrapper>
            <ChampionsHeader
                title={t('championAnalyze.championSearch')}>
                <ChampionsInput
                    inputValue={indivisualVisible}
                    setInputValue={onChangeINidivisualVisible}
                />
            </ChampionsHeader>
            <ChampionsWhiteWrapper>
                <SearchListByLane
                    onClick={onClickLane}
                />
                <ChampionsBar>
                    <ChampionsCname
                        onClick={onClickCname}
                    />
                </ChampionsBar>
                <Suspense fallback={<Loading/>}>
                    <ChampionsList
                        laneVisible={laneVisible}
                        championData={championData}
                        inidivisualVisible={indivisualVisible}
                        choVisible={choVisible}
                    />
                </Suspense>
            </ChampionsWhiteWrapper>
        </Wrapper>
    );
};

export default ChampionsSearch;
